<template>
  <div class="main">
    <div class="wrapper">
      <Gywm title="组织结构"></Gywm>
    </div>
  </div>
</template>
<script>
import Bus from "@/utils/bus.js";
import Gywm from "@/components/GywmContent.vue";
export default {
  data() {
    return {
    };
  },
  mounted() {
    // window.scrollTo(0, 0);
  },
  methods: {
    
  },
  components: {
    Gywm
  }
};
</script>
<style lang="less" scoped>
.main {
  width: calc(100vw - 60px);
  margin: 30px auto;
  .wrapper {
    width: 100%;
  }
}
</style>